const regionNames = typeof Intl.DisplayNames === 'function' ? new Intl.DisplayNames(['en'], { type: 'region' }) : null;

const getCountryName = (code: string): string => {
  if (!regionNames) {
    return code;
  }

  try {
    return regionNames.of(code.trim().toUpperCase()) ?? code;
  } catch {
    return code; // invalid code → fall back to the raw value
  }
};

export default getCountryName;
